<template>
  <v-container fluid>

  <div class="headline text-xs-left">
    Account Setup
  </div>

  <LearnItem>
    <template slot="title">How do I cancel my account? </template>
    You can cancel your account anytime from your <router-link :to="{name: 'Account'}">Account Settings</router-link> page.
    When you cancel your account the system will stop your account and
    (if you had any orders during the month) it will charge the fee for using the
    site that month.
   </LearnItem>
   <LearnItem>
     <template slot="title">How do I change my subscription credit card?</template>
     You can update your credit card anytime from the
     <router-link :to="{name: 'Account'}">Account Settings</router-link> page.
  </LearnItem>

  </v-container>

</template>

<script>

import LearnItem from './LearnItem.vue'

export default {
  components: {
    LearnItem
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

</style>
